"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecorvino-rovella": {
    "c1b55f87": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "chiarelli": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49c0910f": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "cornea": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81790f31": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "ferrari": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43df1710": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "marangi": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8c6ae8d": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "martorano": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8c1b538": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "molenadi": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bf1f8de": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "nuvola": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42b44018": [{
      "hkey": "6aac5aed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "6aac5aed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montecorvino-rovella"
    }],
    "4c3d95da": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "skipSearch": false
    }],
    "sant-eustachio": [{
      "hkey": "2caa4728",
      "slug": "montecorvino-rovella",
      "name": "Montecorvino Rovella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ad3aefd": [{
      "hkey": "6aac5aed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "votraci": [{
      "hkey": "6aac5aed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montecorvino-rovella"
    }]
  }
};
exports["default"] = _default;